<template>
  <router-view style="margin-top: 36px;"/>
</template>

<script>
export default {
  name: 'Layout'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Layout.vue